// extracted by mini-css-extract-plugin
module.exports = {"No_Partner_Selected_Message":"PartnerDashboard_No_Partner_Selected_Message__2VMRR"};